import { AuthStoreState } from "@/features/auth/types"
import { configureStore } from "@/lib/store"

type AuthPersistedState = Pick<
  AuthStoreState,
  | "token"
  | "isAuthenticated"
  | "tokenType"
  | "refreshToken"
  | "isImpersonating"
  | "impersonatorId"
  | "originalAdminToken"
  | "originalAdminRefreshToken"
  | "originalAdminUser"
>

// Store apenas com estado, sem ações
export const authStore = configureStore<AuthStoreState, AuthPersistedState>(
  () => ({
    token: null,
    refreshToken: null,
    tokenType: null,
    isAuthenticated: false,
    user: null,
    organization: null,
    isLoading: false,
    error: null,
    isImpersonating: false,
    impersonatorId: null,
    originalAdminToken: null,
    originalAdminRefreshToken: null,
    originalAdminUser: null,
  }),
  {
    persistOptions: {
      name: "speeke-auth",
      partialize: state =>
        ({
          token: state.token,
          refreshToken: state.refreshToken,
          tokenType: state.tokenType,
          isAuthenticated: state.isAuthenticated,
          user: state.user,
          organization: state.organization,
          isImpersonating: state.isImpersonating,
          impersonatorId: state.impersonatorId,
          originalAdminToken: state.originalAdminToken,
          originalAdminRefreshToken: state.originalAdminRefreshToken,
          originalAdminUser: state.originalAdminUser,
        }) as unknown as AuthPersistedState,
    },
  }
)

export const clearAuthStore = () => {
  authStore.setState({
    token: null,
    refreshToken: null,
    tokenType: null,
    isAuthenticated: false,
    user: null,
    organization: null,
    isLoading: false,
    error: null,
    isImpersonating: false,
    impersonatorId: null,
    originalAdminToken: null,
    originalAdminRefreshToken: null,
    originalAdminUser: null,
  })
}
